import App from './App.svelte';
import { initI18n } from './lib/i18n';
import * as Sentry from "@sentry/svelte";


console.log('Starting app outside');
// Initialize app with async/await
const start = async () => {
  // Check for maintenance mode
  if ((window as any).__MAINTENANCE_MODE__) {
    console.log('Maintenance mode enabled');
    document.getElementById('maintenance')!.style.display = 'block';
    document.getElementById('app')!.style.display = 'none';
    return null;
  }

  console.log('Starting app');
  await initI18n();
  console.log('i18N initialized');

  Sentry.init({
    dsn: "https://d05a74e692547a8be256e09329c3ce24@o4505476244307968.ingest.us.sentry.io/4509157568086016"
  });

  const app = new App({
    target: document.getElementById('app'),
  });

  return app;
};

export default start(); 